import { render, staticRenderFns } from "./DiagnosticImageEdit.vue?vue&type=template&id=493b821a"
import script from "./DiagnosticImageEdit.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports